import { Fragment } from 'react'

export type LinkedInInsightsTagProps = {
    partnerId: string
}

/**
 * Inserts the Linkedin Insights Tag script. To be embedded in the page `<head>`.
 */
export function LinkedInInsightsTag({ partnerId }: LinkedInInsightsTagProps) {
    return (
        <Fragment>
            <script type="text/javascript">
                window._linkedin_partner_id={partnerId}
                window._linkedin_data_partner_ids=window._linkedin_data_partner_ids||[]
                window._linkedin_data_partner_ids.push(_linkedin_partner_id)
            </script>
            <script
                type="text/javascript"
                src="https://snap.licdn.com/li.lms-analytics/insight.min.js"
                async
            />
            <noscript>
                <img
                    height="1"
                    width="1"
                    style={{ display: 'none' }}
                    alt=""
                    src="https://px.ads.linkedin.com/collect/?pid=2041316&fmt=gif"
                />
            </noscript>
        </Fragment>
    )
}
